export class SpotifyUser {
    id: string;
    display_name: string;
    href: string;
    type: string;
    uri: string;
}